import { Item } from '../../operations'
import { CheckStatus } from '../../administration'
import { Check } from '../../administration'

export type MonthRange = { start: string; end: string; label: string }

const pad = (n: number) => String(n).padStart(2, '0')

const toIsoDate = (d: Date) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

export const getMonthRange = (monthsAgo: number): MonthRange => {
    const now = new Date()
    const d = new Date(now.getFullYear(), now.getMonth() - monthsAgo, 1)
    const start = toIsoDate(d)
    const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0)
    const end = monthsAgo === 0 ? toIsoDate(now) : toIsoDate(lastDay)
    const label = d.toLocaleDateString('es-AR', { month: 'short', year: '2-digit' })
    return { start, end, label }
}

export const getLast12MonthRanges = (): MonthRange[] => {
    return [11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0].map(getMonthRange)
}

export const getLast6MonthRanges = (): MonthRange[] => {
    return [5, 4, 3, 2, 1, 0].map(getMonthRange)
}

export const todayStr = (): string => {
    const d = new Date()
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

// Las fechas se guardan como ISO en UTC; se llevan al día local. Las que ya son solo día (YYYY-MM-DD) quedan igual
export const toLocalDateStr =(dateStr: string): string =>
    dateStr.length <= 10 ? dateStr : toIsoDate(new Date(dateStr))

export const isToday = (dateStr?: string): boolean =>
    !!dateStr && toLocalDateStr(dateStr) === todayStr()

export const daysAgoStr =(days: number): string => {
    const d = new Date()
    d.setDate(d.getDate() - days)
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const isInRange = (dateStr: string, range: MonthRange) => {
    const dateOnly = toLocalDateStr(dateStr)
    return dateOnly >= range.start && dateOnly <= range.end
}

export const getItemsSubtotal = (items: Item[]) =>
    items.reduce((sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 0), 0)

export const formatAmount = (amount: number): string =>
    Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(amount)

export const formatNumber = (n: number): string =>
    Intl.NumberFormat('es-AR').format(n)

export const calcTrend = (current: number, previous: number): number | undefined => {
    if (previous === 0) return undefined
    return ((current - previous) / previous) * 100
}

export const isActiveCheck = (check: Check): boolean =>
    !check.archived &&
    check.status !== CheckStatus.PAYED &&
    check.status !== CheckStatus.ANNULLED &&
    check.status !== CheckStatus.REJECTED &&
    check.status !== CheckStatus.DISOWNED

export const getNext7DaysRange = (): { start: string; end: string } => {
    const now = new Date()
    const future = new Date(now)
    future.setDate(future.getDate() + 7)
    return { start: toIsoDate(now), end: toIsoDate(future) }
}
